export enum BucketListRegion {
  Americas = 'Americas',
  Europe = 'Europe',
  Asia = 'Asia',
  Africa = 'Africa',
  MiddleEast = 'Middle East',
  Oceania = 'Oceania',
  Global = 'Global',
  Unknown = 'Unknown'
}

export type BucketListContentType =
  | 'activity'
  | 'research'
  | 'public_activity'
  | 'raw_idea';

export interface IBucketListItem {
  id: string;
  contentType: BucketListContentType;
  title: string;
  description?: string;
  notes?: string;
  tags?: string[];
  imageUrl?: string;
  region: BucketListRegion;
  lat?: number;
  lng?: number;
  address?: string;
  countryCode?: string;
  activityType?: string;
  placeId?: string;
  googlePlaceId?: string;
  websiteUrl?: string;
  types?: string[];
  sourceType?: string;
  videoId?: string;
  link?: string;
  sourceId?: string;
  addedAt: string | Date;
  addedBy: string;
  lastModified?: string | Date;
}

export interface IBucketList {
  id: string;
  userId: string;
  items: IBucketListItem[];
  createdAt: string | Date;
  updatedAt: string | Date;
}

export interface IBucketListByRegion {
  region: BucketListRegion;
  items: IBucketListItem[];
}

export interface AddBucketListItemRequest {
  contentType: BucketListContentType;
  title: string;
  description?: string;
  notes?: string;
  tags?: string[];
  imageUrl?: string;
  region?: BucketListRegion;
  lat?: number;
  lng?: number;
  address?: string;
  countryCode?: string;
  activityType?: string;
  placeId?: string;
  googlePlaceId?: string;
  websiteUrl?: string;
  types?: string[];
  sourceType?: string;
  videoId?: string;
  link?: string;
  sourceId?: string;
}

export interface BucketListDiscoveryResult {
  id: string;
  title: string;
  description?: string;
  imageUrl?: string;
  region: BucketListRegion;
  contentType: BucketListContentType;
  activityType?: string;
  address?: string;
  lat?: number;
  lng?: number;
  tags?: string[];
  inBucketList: boolean;
  bucketListItemId?: string;
}
